<template>
  <div v-if="contentDetail === null">
    <div class="space-y-2">
      <a
        v-for="(premadeBlock, i) in premadeBlocks"
        :key="premadeBlock.name"
        class="block"
        @click="selectPremadeBlock(premadeBlock, i)"
      >
        <premade-header :header-name="premadeBlock.name"></premade-header>
      </a>
    </div>
  </div>

  <div v-else>
    <div class="mb-4 flex items-center justify-between">
      <h2 class="font-inter text-sm font-semibold text-gray-50">
        {{ contentDetail.name }}
      </h2>

      <t-button
        data-testid="premade-back-button"
        xs
        @click="contentDetail = null"
      >
        <template #icon>
          <font-awesome-icon :icon="['fas', 'angle-left']" class="h-[14px]" />
        </template>
        {{ $t("premade.back") }}
      </t-button>
    </div>
    <div
      v-if="
        contentDetail !== null &&
        Array.isArray(contentDetail.blocks) &&
        contentDetail.blocks.length > 0 &&
        contentDetailIndex !== null
      "
      id="readyblocks"
    >
      <VueDraggable
        key="headersblocks"
        :model-value="contentDetail.blocks"
        class="space-y-2"
        item-key="headersblocks"
        :animation="150"
        :group="{ name: 'sections', pull: 'clone', put: false }"
        :sort="false"
      >
        <premade-detail
          v-for="(premadeblock, i) in contentDetail.blocks"
          :key="i"
          :clickable="clickable"
          :block-index="i"
          :block="premadeblock"
          :block-type="contentDetailIndex"
          data-testid="premade-preview-image"
          @click="
            $emit('premade-clicked', { name: contentDetailIndex, index: i })
          "
        >
        </premade-detail>
      </VueDraggable>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import PremadeHeader from "../_internal/PremadeHeader/PremadeHeader.vue";
  import PremadeDetail from "../_internal/PremadeDetail/PremadeDetail.vue";
  import { VueDraggable } from "vue-draggable-plus";
  // import czpremadeblocks from "@/store/premadeblocks/czpremadeblocks";
  // import premadeblocks from "@/store/premadeblocks/premadeblocks";
  // import { useI18n } from "vue-i18n";
  // import { useGeneralStore } from "@/stores/generalStore";
  // import { usePremadeBlocksStore } from "@/stores/premadeBlocksStore";
  import type { IPremadeBlock } from "types/Premadeblocks/IPremadeBlocks";

  import { TButton } from "@topol/twig-ui";

  import { ref, Ref, PropType } from "vue";

  defineProps({
    clickable: {
      type: Boolean,
      default: false,
    },
    premadeBlocks: {
      type: Array as PropType<IPremadeBlock[]>,
      required: true,
    },
  });

  defineEmits(["premade-clicked", "back-to-premades"]);

  const contentDetail: Ref<IPremadeBlock | null> = ref(null);
  const contentDetailIndex: Ref<number | null> = ref(null);

  // const { t } = useI18n();
  // const generalStore = useGeneralStore();
  // const premadeBlocksStore = usePremadeBlocksStore();

  // const premadeBlocks = computed((): IPremadeBlock[] | false  => {
  //   const blocks = premadeBlocksStore.premadeBlocks;

  //   if (!blocks) {
  //     return false;
  //   }

  //   // In the new shape, there is specific name key for each premadeblock,
  //   // so here we can distinguish if it's legacy or new shape
  //   if (Array.isArray(blocks)) {
  //     return blocks;
  //   }

  //   const convertedBlocks = convertLegacyPremadeBlocks(blocks);

  //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
  //   premadeBlocksStore.premadeBlocks = convertedBlocks;

  //   return convertedBlocks;
  // })

  const selectPremadeBlock = (
    premadeBlockCategory: IPremadeBlock,
    categoryIndex: number
  ) => {
    contentDetail.value = premadeBlockCategory;
    contentDetailIndex.value = categoryIndex;
  };

  // const convertLegacyPremadeBlocks = (premadeblocks?: ILegacyPremadeBlocks) => {
  //   const fixedPremadeBlocks: IPremadeBlock[] = [];

  //   if (!premadeblocks) {
  //     return fixedPremadeBlocks;
  //   }

  //   if (premadeblocks.headers) {
  //     fixedPremadeBlocks.push({
  //       name: t("premade.header"),
  //       blocks: premadeblocks.headers,
  //     });
  //   }

  //   if (premadeblocks.content) {
  //     fixedPremadeBlocks.push({
  //       name: t("premade.content"),
  //       blocks: premadeblocks.content,
  //     });
  //   }

  //   if (premadeblocks.ecomm) {
  //     fixedPremadeBlocks.push({
  //       name: t("premade.ecommerce"),
  //       blocks: premadeblocks.ecomm,
  //     });
  //   }

  //   if (premadeblocks.footers) {
  //     fixedPremadeBlocks.push({
  //       name: t("premade.footer"),
  //       blocks: premadeblocks.footers,
  //     });
  //   }

  //   return fixedPremadeBlocks;
  // }
</script>
